// @flow
import React from 'react';
import moment from 'moment';

import { Card, CardHeader } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import FontIcon from 'material-ui/FontIcon';
import { cyan500, grey100, grey300, grey500 } from 'material-ui/styles/colors';

import HUDStepper from './HUDStepper';

const HUD_WIDTH = 400;

function getStyles({ browser, hud, isInPast }) {
  const isMobile = browser.lessThan.medium;

  return {
    cardContainer: {
      background: 'white',
    },

    root: {
      position: 'absolute',
      top: isMobile ? 0 : 80,
      left: isMobile ? 0 : 12,
      width: isMobile ? '100vw' : HUD_WIDTH,
      height: isMobile ? '100vh' : undefined,
      paddingTop: isMobile ? 60 : 0,
      paddingBottom: hud.open ? 12 : 0,
      zIndex: 1302,
    },

    header: {
      display: isMobile ? 'none' : 'flex',
      background: isInPast ? grey500 : cyan500,
    },

    expandIcon: {
      color: 'white',
    },

    title: {
      color: 'white',
      marginTop: 12,
    },

    pastWarning: {
      background: grey100,
    },

    subHeader: {
      paddingLeft: 0,
    },

    datePickerContainer: {
      marginTop: 16,
    },

    inputRangeContainer: {
      margin: 6,
      paddingTop: 24,
      paddingBottom: 24,
      paddingLeft: 12,
      paddingRight: 18,
    },

    stepper: {
      display: hud.open || isMobile ? 'flex' : 'none',
      width: isMobile ? '100vw' : HUD_WIDTH,
      marginBottom: 20,
    },

    radioButtonGroup: {
      marginTop: 16,
    },

    radioButton: {
      marginBottom: 16,
    },

    checkbox: {
      marginTop: 16,
      marginBottom: 16,
      color: grey300,
    },
  };
}

export default props => {
  const {
    browser,
    hud,
    dateRange: { min: startDate },
  } = props;

  const isInPast = startDate.isBefore(moment(), 'day');
  const styles = getStyles({ ...props, isInPast });

  if (browser.lessThan.medium && !hud.open) {
    return null;
  }

  return props.appInDrawMode ? null : (
    <Card
      className="intro-tour__step-2"
      style={styles.root}
      containerStyle={styles.cardContainer}
      expandable
      expanded={hud.open}
      initiallyExpanded={false}
      onExpandChange={expanded => props.toggleHUD(expanded)}
    >
      <CardHeader
        style={styles.header}
        titleStyle={styles.title}
        iconStyle={styles.expandIcon}
        title={
          isInPast ? 'Múltbeli légterek böngészése' : 'Eseti légtér keresése'
        }
        avatar={
          <Avatar
            icon={
              <FontIcon className="material-icons">
                {isInPast ? 'history' : 'flight'}
              </FontIcon>
            }
            color={isInPast ? grey500 : cyan500}
            backgroundColor="white"
          />
        }
        actAsExpander
        showExpandableButton
      />
      {hud.open && (
        <HUDStepper {...props} isInPast={isInPast} styles={styles} />
      )}
    </Card>
  );
};



// WEBPACK FOOTER //
// ./components/HUD/HUD.js